import { Injectable } from '@angular/core';

@Injectable()
export class QlServiceFactoryConfig {
    typesConfig: {
        [key: string]: any;
    };
}
